/**
 * Translates a contextual correct action to a classList method
 *
 * Most presentational changes are handeled by simple class changes. Terms like
 * "add" and "remove" don't always make sense when the presentational result of
 * a method is e.g. showing or hiding it.
 * 
 * action = "close" | "open" | "toggle";
 * result = "add" | "remove" | "toggle";
 *
 * @param action The action to interpret
 */
export function interpretAction(action) {
  if (action === "close") return "remove";
  if (action === "open") return "add";
  return action;
}